export default `Province,Population
Drenthe,493682
Flevoland,423021
Friesland,649957
Gelderland,2085952
Groningen,585866
Limburg,1117201
North Brabant,2562955
North Holland,2879527
Overijssel,1162406
South Holland,3708696
Utrecht,1354834
Zeeland,383488`